import { Box, Heading } from '@razorpay/blade/components';

const Header = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      marginY="spacing.5"
      gap="spacing.5"
      flexWrap={{
        base: 'wrap',
        s: 'nowrap',
      }}>
      <Heading size="xlarge" weight="semibold" marginBottom="spacing.1">
        Salary Structures
      </Heading>
    </Box>
  );
};

export default Header;
